import {
  LESSON_SET_INFO,
} from './action_types';
import { ON_ERROR } from '../../../app_state/action_types';

const initialState = {
  info: {
    tutor: 'tutor',
    student: 'student',
    course: 'course',
    location: 'location',
    address: 'address',
    date: 'date',
    time: 'time',
    status: 'status',
    lastUpdated: 'last upated',
    studentFee: 'student fee',
    tutorFee: 'tutorFee',
    price: 'price',
    charges: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LESSON_SET_INFO:
      return { ...state, info: action.payload };
    case ON_ERROR:
      return { ...state, ...initialState };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/lessons/cards/LessonCard/reducers.js